<div class="lead-generator">
  @if (showQuestionsScreen) {
    <app-booking-questions (submitEvent)="onSubmitEvent($event)" />
  }
  @if (showAlertScreen && alertType && alertMessage) {
    <app-alert
      [isAlertMessageTranslated]="isAlertMessageTranslated"
      [type]="alertType"
      [message]="alertMessage"
    />
  }
</div>
